import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  getModalTitle,
  getModalContent,
  getModalClassName,
  getModalConfig,
  getModalCloseButton,
  getModalOnClose,
} from '@src/redux/selectors/modal';
import { closeModal } from '@src/redux/actions/modal';
import Modal from '@src/components/Modal';
import { RootState } from '@src/redux/interfaces/redux.interface';
import { ModalTitle } from './ModalTitle';
import './styles.scss';

const MODAL_STYLES = {
  overlay: {
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
  },
};

function FrankModal({ title, className, content, closeModal, closeButton, config, onClose }) {
  const modalIsOpen = !!content;
  const updatedConfig = { ...config };

  if (config.disableClose) {
    updatedConfig.shouldCloseOnEsc = false;
    updatedConfig.shouldCloseOnOverlayClick = false;
  }

  return (
    <Modal
      className={classnames('content-modal-container', className, {
        'content-modal-container--without-padding': config.withoutPadding,
      })}
      onClose={() => {
        closeModal();
        onClose && onClose();
      }}
      open={modalIsOpen}
      style={MODAL_STYLES}
      {...updatedConfig}
    >
      {!!title && (
        <ModalTitle
          closeButton={closeButton}
          onClose={() => {
            closeModal();
            onClose && onClose();
          }}
          showBackButton={false}
          showCloseButton={!config.hideCloseButton}
          title={title}
        />
      )}

      {content}
    </Modal>
  );
}

FrankModal.propTypes = {
  className: PropTypes.string,
  closeButton: PropTypes.node,
  closeModal: PropTypes.func.isRequired,
  config: PropTypes.shape({
    disableClose: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    withoutPadding: PropTypes.bool,
  }),
  content: PropTypes.node,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

FrankModal.defaultProps = {
  config: {},
};

export default connect(
  (state: RootState) => ({
    className: getModalClassName(state),
    closeButton: getModalCloseButton(state),
    config: getModalConfig(state),
    content: getModalContent(state),
    onClose: getModalOnClose(state),
    title: getModalTitle(state),
  }),
  { closeModal },
)(FrankModal);
